<script lang="ts" setup>
import type { ProductFactData } from '~/types/product-facts'

defineProps<{
  productFactData: ProductFactData
}>()
</script>

<template>
  <div
    class="
      flex min-w-[280px] flex-col justify-between rounded-2xl bg-main-light-gray p-5 md:min-w-[250px] lg:min-w-[290px]
    "
  >
    <p class="text-sm leading-[1.43] tracking-[-0.01em] text-main-dark md:text-base md:leading-[150%]">
      {{ productFactData.attributes.description }}
    </p>
  </div>
</template>
